import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=6b7037c7&"
import script from "./AddPlan.vue?vue&type=script&lang=js&"
export * from "./AddPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports